export const creditsWarningGlobalAlertDismissedCookieName =
  'creditsWarningGlobalAlertDismissed'
